import { LayoutGrid } from 'lucide-react'
import { NodeKind } from '@/core/document'
import { CollagePanel } from '@/tools/collage/CollagePanel'
import { ToolKind, ToolTab, type NodeTool } from '@/tools/types'

export const COLLAGE_TOOL: NodeTool = {
  kind: ToolKind.Node,
  tab: ToolTab.Collage,
  node: NodeKind.Collage,
  label: 'Collage',
  icon: LayoutGrid,
  appliesTo: () => true,
  Panel: CollagePanel,
}
